import React from 'react';

import { is768Query } from '~/core/scripts/mediaquery-helper';

const isSmallScreen = !is768Query();
const getArray = (count, keyPrefix = '') => [...Array(count)].map((d, i) => ({ key: `${keyPrefix}${i}` }));
const findConfig = (rowIndex, colIndex) =>
  c => c.gridPosition[0] === rowIndex && c.gridPosition[1] === colIndex;

export default ({ rows = 2, columns = 2, config = [], Component = () => null }) => {
  const rowArray = getArray(rows, 'grid__row-');
  const columnArray =getArray(columns, 'grid__col-');
  const colWidth = 100 / (columns);

  if (isSmallScreen) {
    return (
      <div className="grid">
        {config.map(c => <Component key={c.props.state} {...c.props} />)}
      </div>
    );
  }

  return (
    <div className="grid">
      {/* render rows */}
      {rowArray.map((r, rowIndex) => (
        <div className="grid__row" key={r.key}>
          {/* render columns */}
          {columnArray.map((c, colIndex) => {
            const currConfig = config.find(findConfig(rowIndex, colIndex));
            return (
              <div className="grid__col" key={c.key} style={{ width: `${colWidth}%`, minWidth: `${colWidth}%` }}>
                {/* render component */}
                {currConfig ? <Component {...currConfig.props} /> : null}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
